<template>
    <div class="supplier-management-add" v-loading="boxLoad">
        <div class="title-1"> <h3>基本信息</h3></div>
       
        <el-form :model="dataForm" ref="dataForm" :rules="rules" label-position="top">
            <el-row gutter="20">
                <el-col :span="8">
                    <el-form-item label="供应商全称" prop="name">
                        <!-- <ab-select
                            url="/bas/client/basSupplier/listByName"
                            placeholder="请输入英文名称，如有括号，请采用英文输入法下的括号"
                            inputKey="name"
                            descKey="name"
                            v-model="dataForm.name"
                            isNotClear
                            :urlData="{isEnabled: 1}"
                            @handleSelect="itemCodeSelect"  
                            :disabled='isDisable'                          
                        >
                        </ab-select> -->

                        <el-autocomplete
                            v-model.trim="dataForm.name"
                            placeholder="请输入英文名称，如有括号，请采用英文输入法下的括号"
                            :fetch-suggestions="querySearchAsync"
                            clearable
                            @select="itemCodeSelect"
                            value-key="name"
                            :disabled='isDisable'  
                        >
                        </el-autocomplete>
                    </el-form-item>
                </el-col>
                 <el-col :span="8">
                    <el-form-item label="地址区域" prop="areaIdDesc">
                        <ab-address v-model="dataForm.areaIdDesc" @change="selectArea" ref="area" :disabled="dataForm.approvalStatusDesc == '已核准'"></ab-address>
                    </el-form-item>
                </el-col>
                 <el-col :span="8">
                    <el-form-item label="详细地址" prop="address">
                        <el-input v-model="dataForm.address" placeholder="请输入详细地址" :disabled="dataForm.approvalStatusDesc == '已核准'"/>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-divider style="margin:10px 0 40px;border-top:1px solid #F0F2F5"/>

        <div class="title-2">
            <h3>银行账户信息</h3>
            <div @click="haveAccount">
                <ab-svg name="add"></ab-svg>
                选择已有账号
            </div>
        </div>
        
        <el-alert title="新账号请上传银行资料盖章件" type="warning" />
        <vxe-table 
            border 
            show-overflow
            resizable 
            keep-source
            auto-resize
            max-height="520"
            :data="vuexData" 
            v-if="reload"
            :edit-config="{trigger: 'click', mode: 'row', showUpdateStatus: true, icon: 'abcd', autoClear: false}" 
            ref="elxEditableAccount"
            :row-class-name="rowStyle"
            :cell-class-name="cellStyle"
            :edit-rules="vuexrules">
            <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>

            <vxe-column field="number" title="SWIFT号/联行号" :edit-render="{autofocus: '.vxe-input--inner'}">
                <template v-slot="{row}">
                    <span>{{row.number}}</span>
                </template>
                <template v-slot:edit="{ row }">
                    <ab-select
                        url="/bas/basBank/pageList"
                        placeholder="请输入SWIFT号/联行号"
                        inputKey="number"
                        descKey="number"
                        isNotClear
                        v-model="row.number"
                        :urlData="{pageNum: 1, pageSize: 10}"
                        @handleSelect="bankChange($event,row)"
                        :disabled="(row.isSubmit && row.id && !isDisabled) || row.id"
                    >
                    </ab-select>
                </template>
            </vxe-column>

            <vxe-column field="countryName" title="国家地区" :edit-render="{}">
                <template v-slot="{row}">
                    <span>{{row.countryName}}</span>
                </template>
                <template v-slot:edit="{ row }">
                    <ab-select
                        url="/bas/basArea/listCountry"
                        placeholder="请选择国家地区"
                        inputKey="keyWord"
                        descKey="name"
                        isNotClear
                        v-model="row.countryName"
                        :urlData="{pageNum: 1, pageSize: 10, type: 1, isEnabled: 1}"
                        @handleSelect="countryChange($event, row)"
                        :disabled="(row.isSubmit && row.id && !isDisabled) || row.rowDis || row.approvalStatusDesc == '已核准'"
                    >
                    </ab-select>
                </template>
            </vxe-column>

            <vxe-column field="bankName" title="开户银行" :edit-render="{}">
                <template #edit="{ row }">
                    <vxe-input v-model="row.bankName" type="text" :disabled="(row.isSubmit && row.id && !isDisabled) || row.rowDis || row.approvalStatusDesc == '已核准'"></vxe-input>
                </template>
            </vxe-column>

            <vxe-column field="account" title="银行账号" :edit-render="{}">
                <template #edit="{ row }">
                
                    <vxe-input v-model="row.account" type="text" :disabled="row.isSubmit && row.id && !isDisabled" @change="checkSupplierAccountEntry($event, row)"></vxe-input>
                </template>
            </vxe-column>
         
            <vxe-column field="currencyIdDesc" title="币别" :edit-render="{}">
                <template v-slot="{row}">
                    <span>{{row.currencyIdDesc}}</span>
                </template>
                
                <template v-slot:edit="{ row }">
                    <ab-select
                        url="/bas/basCurrency/list"
                        placeholder="请输入币别"
                        inputKey="name"
                        descKey="name"
                        cueString="币别"
                        v-model="row.currencyIdDesc"
                        :urlData="{pageNum: 1, pageSize: 10}"
                        @handleSelect="currencyChange($event,row)"
                        :disabled="row.isSubmit && row.id && !isDisabled"
                    ></ab-select>
                </template>
            </vxe-column>

            <vxe-column field="accountName" title="账号名称" :edit-render="{}">
                <template #edit="{ row }">
                    <vxe-input v-model="row.accountName" type="text" disabled></vxe-input>
                </template>
            </vxe-column>

            <vxe-column field="isDefault" title="默认账号">
                <template #default="{ row }">
                    <el-switch v-model="row.isDefault" :active-value="1" :inactive-value="0" @change="isDefaultChange($event, row, 'vuexData')"/>
                </template>
            </vxe-column>

            <vxe-column field="address" title="操作">
                <template #default="{rowIndex , row}">
                    <el-button link type="primary" @click="removeAccountRow(row, rowIndex)" style="color:#FF0000">删除</el-button>
                </template>
            </vxe-column>
        </vxe-table>
        <div class="addCargo" >
            <span @click="addnsiddjfs"><ab-svg name="add"></ab-svg> 新增一行</span>
        </div>

        <el-divider style="margin:40px 0 40px;border-top:1px solid #F0F2F5"/>

        <div class="title-3">
            <h3>发货信息</h3>
        </div>

        <el-alert title="涉及需到供应商处提货才需填写" type="warning" />

        <vxe-table 
            ref="elxEditable"
            border 
            show-overflow
            resizable 
            keep-source
            auto-resize
            max-height="520"
            :data="vuexData1" 
            v-if="reload1"
            :edit-config="{trigger: 'click', mode: 'row', showUpdateStatus: true,icon: 'abcd'}" 
            :row-class-name="rowStyle"
            :cell-class-name="cellStyle"
            :edit-rules="vuexrules1">
            <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>

            <vxe-column field="company" title="提货公司" :edit-render="{autofocus: '.vxe-input--inner'}">
                <template v-slot:edit="{ row }">
                     <vxe-input v-model="row.company" type="text"></vxe-input>
                </template>
            </vxe-column>

            <vxe-column field="linkman" title="联系人" :edit-render="{}">
                <template #edit="{ row }">
                    <vxe-input v-model="row.linkman" type="text"></vxe-input>
                </template>
            </vxe-column>

            <vxe-column field="mobile" title="联系电话" :edit-render="{}">
                <template #edit="{ row }">
                    <vxe-input v-model="row.mobile" type="text"></vxe-input>
                </template>
            </vxe-column>
         
            <vxe-column field="areaIdDesc" title="发货区域" :edit-render="{}">
                <template v-slot="{row}">
                    <span>{{row.areaDesc}}</span>
                </template>
                <template v-slot:edit="{ row }">
                    <ab-address 
                        v-model="row.areaIdDesc" 
                        @change='(val, valdetail)=>{return adressChange(val, valdetail, row)}' 
                        placeholder= "请选择发货区域"
                    ></ab-address>
                </template>
            </vxe-column>

            <vxe-column field="linkAddress" title="发货地址" :edit-render="{}">
                <template #edit="{ row }">
                    <vxe-input v-model="row.linkAddress" type="text"></vxe-input>
                </template>
            </vxe-column>

            <vxe-column field="isDefault" title="默认地址">
                <template #default="{ row }" >
                    <el-switch v-model="row.isDefault" :active-value="1" :inactive-value="0" @change="isDefaultChange($event, row, 'vuexData1')"/>
                </template>
            </vxe-column>

            <vxe-column field="address" title="操作">
                <template #default="{rowIndex , row}">
                    <el-button link type="primary" @click="removeLinkRow(row, rowIndex)" style="color:#FF0000">删除</el-button>
                </template>
            </vxe-column>
        </vxe-table>
        <div class="addCargo" >
            <span @click="addShipments"><ab-svg name="add"></ab-svg> 新增一行</span>
        </div>    
        
        <ab-upload :params="uploadParams" ref="fileUpload" @update-billsId="updateBillsId"></ab-upload>

        <div class="footers">
            <el-button @click="collback">返回</el-button>
            
            <el-button type="primary" @click="handle('/bas/client/basSupplier/submit')" v-if="!routeQuery.cache"  :loading="showLoad">提交</el-button>
            <el-button type="primary" @click="revise(false)" :loading="showLoad" v-else>提交</el-button><!-- 修改 -->
        </div>

        <el-dialog
            v-model="dialogVisible"
            title="请选择"
            width="50%"
            class="zhanghao"
        >
            <p style="font-size: 16px; margin-bottom: 10px">系统已存在以下账号，请根据需要选择使用！</p>
            <ab-table
                class="materialTable"
                ref="table"
                showSelection
                selectionWidth="45"
                indexWidth="50"
                widths="140"
                isFilter="operator"
                :column-list="columns"
                :table-list="tableData"
                :handleSelectionChange="selectionChange"
            >
            </ab-table>

            <template #footer>
                <span class="dialog-footer">
                    <el-button type="primary" @click="confirmSelect" :disabled="selectArr.length !== 1" :class="{active: selectArr.length !== 1}">确定</el-button>
                    <el-button @click="dialogVisible = false">取消</el-button>                    
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>

export default {
    name: 'supplier-management-add',
    data() {
       const nameValidator= (rule, value, callback)=> {
            if (!/^((?!:|"|%|&|\*|<|>|（|）|@|#|\^|~|\[|\]|\|).)*$/.test(value)) {
                callback(new Error('请输入英文名称,不能包括中文括号和%&*<>@#~^[]|'))
            }
            if ((this.isArea('香港') || this.isArea('台湾')) && !/^[a-z\s()\.\-\/\\\,0-9']+$/i.test(value)) {
                callback(new Error('请输入规范字符'))
            }
            callback()
        }
        return {
            id:'',
            boxLoad: false,
            dataForm:{
                areaList: []
            },
            reload: true,
            reload1: true,
            rules: {
                name: [
                    { required: true, message: '请输入名称', trigger: 'change' },
                    { max: 100, message: '最大长度100个字符', trigger: 'change' },
                    { validator: nameValidator, trigger: 'blur' }
                ],
                areaIdDesc: [
                    { required: true, message: '请选择地址区域', trigger: 'change'}
                ],
                 address: [
                    { required: true, message: '请输入详细地址', trigger: 'blur'},
                    { max: 200, message: '详细地址最大长度200个字符', trigger: 'blur'}
                ],
            },
            vuexData:[],
            vuexrules: {
                number: [
                    { required: true, message: '请输入SWIFT号/联行号'},
                    { validator:  ({ cellValue }) => {
                        if(cellValue.length == 8 || cellValue.length == 11) {
                            if(!/^[a-zA-Z]+$/.test(cellValue) && !/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/.test(cellValue)) {
                                return new Error(`长度为${cellValue.length}位时，只能是纯字母或字母+数字`)
                            }
                        }else if(cellValue.length == 12) {
                            if(!/^[0-9]*$/.test(cellValue)) {
                                return new Error('长度为12位时，只能是纯数字')
                            }
                        }else {
                            return new Error('长度只能为8位，11位，12位')
                        }
                    }}
                ],
                bankName: [
                    { required: true, message: '请输入开户银行' }
                ],
                account: [
                    { required: true, message: '请不要输入下列符号："%&*<>@#~^[]|及空格' }
                ],
                currencyIdDesc: [
                    { required: true, message: '请选择币别' }
                ],
                isDefault: [
                    { required: true, message: '请选择' }
                ],
                countryName: [
                    { required: true, message: '请选择国家和地区' }
                ]
            },
            vuexData1:[],
            vuexrules1:{
                company: [
                    { required: true, message: '请输入提货公司' }
                ],
                linkman: [
                    { required: true, message: '请输入联系人'},
                    { validator: ({ cellValue }) => {
                            if (cellValue) {
                                if (cellValue.length > 50) {
                                    return new Error('联系人最大长度50位')
                                }
                            }
                        }
                    }
                ],
                mobile: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    { validator: ({ cellValue }) => {
                            if (cellValue) {
                                if (!/^[\d\s]+$/.test(cellValue)) {
                                    return new Error('请输入正确的手机号码')
                                }
                            }
                        }
                    }
                ],
                areaDesc: [
                    { required: true, message: '请选择发货区域' }
                ],
                isDefault: [
                    { required: true, message: '请选择' }
                ],
            },
            // 附件管理
            uploadParams: {
                coreBillIds: '',
                coreBillNumbers: '',
                sourceBillId: '',
                sourceBillNumber: '',
                sourceBillType: 'Supplier',
                billType: '',
                items: []
            },
            //弹出框
            dialogVisible: false,
            columns: [
                {
                    props: "bankIdDesc",
                    labels: "开户银行",
                    widths: 90,
                },
                {
                    props: "accountNumber",
                    labels: "银行账号",
                    widths: 90
                },
                {
                    props: "code",
                    labels: "SWIFT/联行号",
                    widths: 90,
                },
                {
                    props: "currencyIdDesc",
                    labels: "币别",
                    widths: 50,
                    align: 'center'
                }
            ],
            tableData:[],
            // 跳转参数
            routeQuery: {},
            //详情
            approvalStatusDesc: '',
            //编码
            number: '',
            showLoad: false,
            selectArr: [],
            // 附件临时id
            tempBillId: undefined,
            isBankFlag: false,
            // 数据是查询来的
            isQuery: false,
            haveFile: false,
        }
    },
    computed: {
        mainTabs: {
            get () {
                return this.$store.state.common.mainTabs
            },
            set (val) {
                this.$store.commit('common/updateMainTabs', val)
            }
        },
        isDisable () {
            return !['', undefined, '已保存'].includes(this.dataForm.statusDesc)
        },
        mainTabs: {
            get() {
                return this.$store.state.mainTabs
            },
            set(val) {
                this.$store.commit('updateMainTabs', val)
            }
        },
        mainTabsActiveName: {
            get () { return this.$store.state.mainTabsActiveName },
            set (val) { this.$store.commit('updateMainTabsActiveName', val) }
        },
    },
    watch:{
        'dataForm.name'(val){
            if(this.vuexData.length){
                this.vuexData.forEach((item)=>{
                    item.accountName = val
                })
            }
            this.isReload1()
        }
    },
    methods:{
        collback () {
            this.removeTabHandle(this.mainTabsActiveName)
        },
        removeTabHandle(tabName) {
            this.mainTabs = this.mainTabs.filter(item => item.index !== tabName)
            if (tabName) {
                this.$router.push({ path: "/supplier-management-list" })
            }
        },
         //模糊搜索
        querySearchAsync(queryString, cb){
            let params = Object.assign({}, {name: queryString, isEnabled: 1})
            this.$post('/bas/client/basSupplier/listByName', params).then(({ data }) => {
                if (data.result && data.code === 'C0000') {
                    cb(data.result.list)
                }
            })
        },
        selectionChange(arr) {
            this.selectArr = arr
        },
        rowStyle ({ row, rowIndex }) {
            if (row && row.classifyStatus === 1) {
                return 'yellow-row'
            } else {
                return ''
            }
        },
        cellStyle ({row, column, rowIndex, columnIndex}) {
            if (row.increaseFlag && column.property == 'price') {
                return 'red-cell'
            } else if (typeof row.increaseFlag == 'number' && !row.increaseFlag && column.property == 'price') {
                return 'blue-cell'
            }
        },
        // 表格内选择区域
        countryChange (arr, row) {
            if(arr) {
                row.countryId = arr.id
                row.countryName = arr.name
            }
        },
        //银行账号新增
        addnsiddjfs(){
            this.vuexData.push({number:'',countryName: '' ,bankName:'',account:'',currencyIdDesc:'', accountName: this.dataForm.name, isDefault: 0})
            this.isReload()
            this.initUpload()
        },
        isReload () {
            this.reload = false
            this.$nextTick(() => {
                this.reload = true
            })
        },
        addShipments(){
            this.vuexData1.push({
                areaId: '',
                areaIdDesc: '',
                areaDesc: '',
                addressType: '04',
                addressTypeDesc: ['04'],
                isDefault: 0,
                action: 1
            })
            this.isReload1()
        },
        isReload1 () {
            this.reload1 = false
            this.$nextTick(() => {
                this.reload1 = true
            })
        },
        // 基本信息选择地址
        selectArea (areaId, areaList) {
            this.dataForm.areaId = areaId.join(',')
            if(areaList){
                this.dataForm.areaList = areaList.split('/')
            }
            
            this.nameReplace()
            this.initUpload()
        },        
        // 选择SWIFT号/联行号
        bankChange (v, row) {
            if (!v || !v.id) {
                row.bank=''
                row.bankName=''
                row.countryName = ''
                if (v.name) {
                    row.rowDis = false
                }
            } else {
                row.bank = v.id
                row.bankName = v.name
                row.number = v.number
                row.countryId = v.countryId
                row.countryName = v.countryIdDesc
                row.rowDis = true
            }
            this.checkSupplierAccountEntry(v, row)
        },        
        // 选择币别
        currencyChange (v, row) {
            if (!v) {
                row.currencyId = ''
                row.currencyIdDesc = ''
            } else {
                if (v.id) {
                    row.currencyId = v.id
                    row.currencyIdDesc = v.name
                }
                
            }
            this.checkSupplierAccountEntry(v, row)
        },
        adressChange(areaIdDesc, areaList, row){
            row.areaId = areaIdDesc ? areaIdDesc.join(',') : ''
            if(areaList){
                row.areaDesc = areaList
            }           
        },
        // 查询银行账户是否存在
        checkSupplierAccountEntry (v, row, flag) {
            if (row.currencyId && row.bank && row.account) {
                this.$post('/bas/client/basSupplier/checkSupplierAccountEntry', { parentId: this.dataForm.id, bank: row.bank, account: row.account, currencyId: row.currencyId }).then(({ data }) => {
                if (data && data.code === 'C0000' && data.result) {
                    if(flag) {
                        this.vuexData[this.vuexData.length - 1].isQuery = true
                    }
                    row.isQuery = true
                } else {
                    row.isQuery = false
                    if(flag) {
                        this.vuexData[this.vuexData.length - 1].isQuery = false
                    }
                }
                this.initUpload()
                })
            }
        },
        //供应商全称
        itemCodeSelect(item){
            this.dataForm.name= item.name
            this.isBankFlag = false
            if (item) {
                this.nameReplace()
                this.checkSupplier()
            }
        },
        // 供应商名称根据地区替换
        nameReplace () {
            let value = this.dataForm.name
            if (value) {
                if (this.dataForm.areaList && this.dataForm.areaList.length && !this.isArea('中国')) {
                    value = value.toLocaleUpperCase().replace(/[\u4e00-\u9fa5]/gi, "")
                }
                this.dataForm.name = value.trim()
            }
        },
        // 判断地址
        isArea (str) {
            if (this.dataForm.areaList && this.dataForm.areaList.length) {
                if (str === '中国') {
                if (this.dataForm.areaList[0] === str) {
                    return true
                }
                } else {
                if (this.dataForm.areaList[0].includes(str) || (this.dataForm.areaList[1] && this.dataForm.areaList[1].includes(str))) {
                    return true
                }
                }
            }
            return false
        },
        // 查询已有供应商
        checkSupplier () {
            let a = this.dataForm.name
            if (!this.dataForm.name) return
            this.$post('/bas/client/basSupplier/checkSupplier', { name: a }).then(({ data }) => {
                if (data && data.code === 'C0000') {
                    if (data.result) {
                        if (['已提交', '已审核'].includes(data.result.statusDesc)) {
                            this.$confirm('该供应商已存在数据库， 系统将自动为您添加到供应商列表？', '温馨提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'info',
                                closeOnClickModal: false
                            }).then(() => {
                                this.isBankFlag = true
                                this.vuexData = []
                                this.setSupplier(data.result)
                                this.revise(true)
                                setTimeout(()=>{
                                    this.$router.push({
                                        path: '/supplier-management-add',
                                        query: {
                                            action: 'detail',
                                            id: data.result.id,
                                            cache: true
                                        }
                                    })
                                },400)
                            }).catch(() => {
                                this.isBankFlag = false
                                this.isQuery = false
                                this.dataForm.name = ''
                                this.dataForm.id = ''
                            })
                        }
                    } else {
                        this.isQuery = false
                    }
                    this.initUpload()
                }else{
                    this.$message({
                        type: 'error',
                        message: data.message,
                        offset: 380,
                        grouping: true,
                    })
                }
            })
        },
        setSupplier (data) {
            this.dataForm.number = data.number
            this.dataForm.isEnabled = data.isEnabled
            this.dataForm.name = data.name
            this.dataForm.shortName = data.shortName
            this.dataForm.areaIdDesc = data.areaIdDesc
            this.dataForm.areaDesc = data.areaDesc
            this.dataForm.areaId = data.areaId
            this.dataForm.address = data.address
            this.dataForm.address = data.address
            if (data.id) {
                this.dataForm.id = data.id
            }
            this.id = data.id
        },
        // 校验函数
        validate () {
            return new Promise((resolve, reject) => {
                this.$refs.dataForm.validate((valid, fields) => {
                    if (valid) {
                        this.$refs.elxEditableAccount.validate(true).then(valid => {
                            if (valid) {
                                return reject(valid)
                            } else {
                                this.$refs.elxEditable.validate(true).then(valid => {
                                    if (valid) {
                                        return reject(valid)
                                    } else {
                                        this.showLoad = false
                                        return resolve()
                                    }
                                })
                            }
                        }).catch(msg => {
                            return reject(msg)
                        })
                        
                    } else {
                        this.showLoad = false
                        return reject(fields)
                    }
                })
            })
        },
        // 保存提交
        handle (url) {
            
            this.validate().then(() => {                
                this.$refs.fileUpload.validate().then(()=>{                    
                    this.dataForm.supplierAccountList = this.vuexData
                    this.dataForm.supplierLinkList = this.vuexData1
                    this.dataForm.shortName = this.dataForm.name.substring(0, this.dataForm.name.indexOf(' ') != -1 ? this.dataForm.name.indexOf(' ') : this.dataForm.name.length)
                    this.showLoad = true
                    this.$post(url, this.dataForm).then(({ data }) => {
                        if (data && data.code === 'C0000') {
                            this.$message({
                                type: 'success',
                                message: data.message,
                                offset: 380,
                                grouping: true,
                            })
                            this.routeQuery.id = this.dataForm.id || data.result
                            if (this.$utils.getSessionStorage('isNewSupplier')) {
                                this.$utils.setSessionStorage('newSupplier', {id: data.result, name: this.dataForm.name})
                                this.$utils.removeSessionStorage('isNewSupplier')
                                this.mainTabs.filter(item => item.name !== this.menuActiveName) // 删除
                                this.$router.push({
                                    path: this.routeQuery.orders.returnPath,
                                    query: this.routeQuery.orders
                                })
                            }   
                            this.init()
                            this.$router.push('supplier-management-list')
                        } else {
                            this.$message({
                                type: 'error',
                                message: data.message,
                                offset: 380,
                                grouping: true,
                            })
                        }
                    }).finally(() => {
                        setTimeout(() => {
                            this.showLoad = false
                        }, 500)
                        
                    })
                })
            })
        },    
        // 默认账号/地址
        isDefaultChange (v, row, obj, flag) {
            if (row.isDefault) {
                this[obj].map(item => {
                    if (item !== row) {
                        item.isDefault=0
                    }
                })
            }
            if (((row.accountEntryPrincipalId || row.supplierLinkmanEntryPrincipalId)) || flag) {
                this.dataForm.supplierAccountList = this.vuexData
                this.dataForm.supplierLinkList = this.vuexData1
                this.$post('/bas/client/basSupplier/isDefaultChange', this.dataForm).then(({ data }) => {
                    if (data && data.code === 'C0000') {
                        this.$message({
                            type: 'success',
                            message: data.message,
                            offset: 380,
                            grouping: true,
                        })
                    } else {
                        this.$message({
                            type: 'error',
                            message: data.message,
                            offset: 380,
                            grouping: true,
                        })
                    }
                })
            }
        },
        //已有银行账号
        haveAccount(){
            this.dialogVisible = true
        },
        init (val) {
            if(this.routeQuery.id || this.dataForm.id || this.id) {
                let data = {id: (this.routeQuery.id || this.dataForm.id || this.id)}
                this.$post('/bas/client/basSupplier/listByPrincipal', data).then(({ data }) => {
                if (data && data.code === 'C0000') {
                    if(data.result.length > 0) {
                        this.tableData = data.result
                        if (this.isBankFlag) {
                            this.dialogVisible = true
                            this.isBankFlag = false
                        }
                    }
                }else{
                    this.$message({
                            type: 'error',
                            message: data.message,
                            offset: 380,
                            grouping: true,
                        })
                }
                })
            }
            this.isQuery = false
            if (this.routeQuery.id || this.dataForm.id || this.id) { // 详情
                this.boxLoad = true
                this.$get('/bas/client/basSupplier/get', { id: this.routeQuery.id || this.dataForm.id || this.id }).then(({ data }) => {
                    if (data && data.code === 'C0000') {
                        this.dataForm = data.result
                        // 解决保存后提交商业登记证必填校验失败bug
                        this.dataForm.areaList = []
                        this.dataForm.areaList[0] = data.result.areaDesc
                        this.vuexData = data.result.supplierAccountList
                        this.approvalStatusDesc = data.result.approvalStatusDesc
                        this.vuexData1 = data.result.supplierLinkList || []         
                        this.$post('/oms/billAttach/queryBySourceBillIds', {sourceBillIdList: [this.dataForm.id], sourceBillType: 'Supplier'}).then(({data}) => {
                            if(data.result && data.result[this.dataForm.number]) {
                                this.haveFile = data.result[this.dataForm.number].some(e=>e.attachType == '030')
                            }
                            this.initUpload()
                        })
                    }else {
                        this.$message({
                            type: 'error',
                            message: data.message,
                            offset: 380,
                            grouping: true,
                        })
                    }
                }).finally(() => {
                    this.boxLoad = false
                })
            } else {
                this.vuexData = []
                this.vuexData1 = []
                this.dataForm = {
                    areaList: []
                }
                this.initUpload()
            }
        },
        /**
         * 附件
         */
        // 初始化附件参数
        initUpload () {
            this.uploadParams.sourceBillId = this.dataForm.id
            this.uploadParams.sourceBillNumber = this.dataForm.number
            setTimeout(() => {
                let items = [
                    {
                        title: '商业登记证',
                        attachType: '030',
                        required: this.dataForm.cushionMoney && this.dataForm.areaList[0] && this.dataForm.areaList[0].indexOf('中国香港') != -1 && !this.haveFile
                    },
                    {
                        title: '银行资料盖章件',
                        attachType: '020',
                        required: this.bankFilesRequired(),
                        errorTips: '新添加的银行，请提供银行资料以便核对'
                    },
                ]
                this.uploadParams.items = items
            }, 500)
        },
        // 银行账号附件是否必填
        bankFilesRequired () {
            for (let item of this.vuexData) {
                if (!item.rowDis && !item.status) {
                    return true
                }
            }
            return false
        },
        // 删除分录
        removeAccountRow (row, rowIndex) {
            this.$confirm('确定删除该行数据?','温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (row.id && row.accountEntryPrincipalId) {
                    this.$post('/bas/client/basSupplier/delAccount', row).then(({ data }) => {
                        if (data && data.code === 'C0000') {
                            this.$message({
                                type: 'success',
                                message: data.message,
                                offset: 380,
                                grouping: true,
                            })
                            this.routeQuery.id = this.dataForm.id
                            this.init()
                        } else {
                            this.$message({
                                type: 'error',
                                message: data.message,
                                offset: 380,
                                grouping: true,
                            })
                        }
                    })
                } else {
                    this.$message({
                        type: 'success',
                        message: '删除成功',
                        offset: 380,
                        grouping: true,
                    })
                }
                this.$refs.elxEditableAccount.remove(row)
                this.vuexData.splice(rowIndex, 1)
                this.initUpload()
            })
        },
        // 删除分录
        removeLinkRow (row, rowIndex) {
            this.$confirm('确定删除该行数据?','温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (row.id && row.supplierLinkmanEntryPrincipalId) {
                this.$post('/bas/client/basSupplier/delLinkman', row).then(({ data }) => {
                    if (data && data.code === 'C0000') {
                        this.$message({
                            type: 'success',
                            message: data.message,
                            offset: 380,
                            grouping: true,
                        })
                        this.routeQuery.id = this.dataForm.id
                        this.init()
                        this.initUpload()
                    } else {
                        this.$message({
                            type: 'error',
                            message: data.message,
                            offset: 380,
                            grouping: true,
                        })
                    }
                })
                } else {
                    this.$message({
                        type: 'success',
                        message: '删除成功',
                        offset: 380,
                        grouping: true,
                    })
                }
                this.$refs.elxEditable.remove(row)
                this.vuexData1.splice(rowIndex, 1)
                this.initUpload()
            })
        },
        //弹框确定
        confirmSelect() {
            let flag = false
            if(this.vuexData.length > 0 && this.selectArr.length > 0) {
                this.vuexData.forEach(ele=>{
                    this.selectArr.forEach(e=>{
                        if(e.id === ele.id) {
                            flag = true
                        }
                    })
                })
            }
            if(flag) {
                this.$message({
                    type: 'error',
                    message: `选择的账户中已包含在列表之中`,
                    offset: 380,
                    grouping: true,
                })
                return
            }
            if(this.vuexData.length ==1 && !this.vuexData[0].id && !this.vuexData[0].code && !this.vuexData[0].accountNumber && !this.vuexData[0].currencyIdDesc && !this.vuexData[0].currencyId) {
                this.vuexData = []
            }
            let ele = this.selectArr[0]
            let obj = {
                id: ele.id,
                number: ele.code,
                account: ele.accountNumber,
                currencyIdDesc: ele.currencyIdDesc,
                currencyId: ele.currencyId,
                bankName: ele.bankIdDesc,
                countryId: ele.countryId,
                countryName: ele.countryName,
                bank: ele.bankId,
                isDefault: 0,
                isSubmit: false,
                accountName: this.dataForm.name
            }
            this.vuexData.push(obj)
            this.confirmAccountRow(obj, true)
            this.dialogVisible = false
            this.checkSupplierAccountEntry('e', obj)
            this.isReload()
        },
        // 银行账号提交分录
        confirmAccountRow (row, flag) {
            /* if(!row.isQuery && !flag) {
                this.$refs.fileUpload.validate().then(()=>{
                    if(flag) {
                        row.parentId = this.dataForm.id
                        this.$post('/bas/client/basSupplier/submitAccount', row).then(({ data }) => {
                            if (data && data.code === 'C0000') {
                                this.$message({ message: data.message, type: 'success', offset: 380, grouping: true})
                                this.routeQuery.id = this.dataForm.id
                                this.init()
                            } else {
                                this.$message({ message: data.message, type: 'error', offset: 380, grouping: true})
                            }
                        })
                    }else{
                        this.$refs.elxEditableAccount.validate(row).then(() => {
                            row.parentId = this.dataForm.id
                            this.$post('/bas/client/basSupplier/submitAccount', row).then(({ data }) => {
                                if (data && data.code === 'C0000') {
                                    this.$message({ message: data.message, type: 'success', offset: 380, grouping: true})
                                    this.routeQuery.id = this.dataForm.id
                                    this.isBankFlag = false
                                    this.init()
                                    row.isSubmit = !row.isSubmit
                                } else {
                                    this.$message({ message: data.message, type: 'error', offset: 380, grouping: true})
                                }
                            })
                        })
                    }
                },()=>{
                    console.log(456);
                })            
            } */

            if(flag) {
                row.parentId = this.dataForm.id
                this.$post('/bas/client/basSupplier/submitAccount', row).then(({ data }) => {
                    if (data && data.code === 'C0000') {
                        this.$message({ message: data.message, type: 'success', offset: 380, grouping: true})
                        this.routeQuery.id = this.dataForm.id
                        this.init()
                    } else {
                        this.$message({ message: data.message, type: 'error', offset: 380, grouping: true})
                    }
                })
            }else{
                this.$refs.elxEditableAccount.validate(row).then(() => {
                    row.parentId = this.dataForm.id
                    this.$post('/bas/client/basSupplier/submitAccount', row).then(({ data }) => {
                        if (data && data.code === 'C0000') {
                            this.$message({ message: data.message, type: 'success', offset: 380, grouping: true})
                            this.routeQuery.id = this.dataForm.id
                            this.isBankFlag = false
                            this.init()
                            row.isSubmit = !row.isSubmit
                        } else {
                            this.$message({ message: data.message, type: 'error', offset: 380, grouping: true})
                        }
                    })
                })
            }
        },
        // 发货信息提交分录
        confirmLinkRow (row, flag) {
            this.$refs.elxEditable.validate(row).then(() => {
                row.parentId = this.dataForm.id
                this.$post('/bas/client/basSupplier/submitLinkman', row).then(({ data }) => {
                    if (data && data.code === 'C0000') {
                        this.$message({ message: data.message, type: 'success', offset: 380, grouping: true})
                        this.routeQuery.id = this.dataForm.id
                        row.isSubmit = !row.isSubmit
                        this.init()
                    } else {
                    this.$message({ message: data.message, type: 'error', offset: 380, grouping: true})
                    }
                })
            })
        },
        // 更新附件id
        updateBillsId (tempBillId) {
            this.tempBillId = tempBillId
            this.dataForm.tempBillId = tempBillId;
        },
        //修改提交
        revise(flag){
            this.validate().then(() => { 
                this.$refs.fileUpload.validate().then(()=>{                                
                    this.dataForm.supplierAccountList = this.vuexData
                    this.dataForm.supplierLinkList = this.vuexData1
                    this.dataForm.shortName = this.dataForm.name.substring(0, this.dataForm.name.indexOf(' ') != -1 ? this.dataForm.name.indexOf(' ') : this.dataForm.name.length)
                    this.showLoad = true
                    this.$post('/bas/client/basSupplier/submit', this.dataForm).then(({ data }) => {
                            if (data && data.code === 'C0000') {
                            this.$message({ message: data.message, type: 'success', offset: 380, grouping: true})
                            this.init()
                            if(!flag){
                                this.collback()
                            }
                        } else {
                            this.$message({ message: data.message, type: 'error', offset: 380, grouping: true})
                        }
                    }).finally(e => {
                        setTimeout(() => {
                            this.showLoad = false
                        }, 500)
                    })
                })
            })
        }

    },
    created() {},
    activated () {
        let query = this.$route.query || {}
        this.routeQuery = Object.keys(query).length ? query : this.routeQuery
        if (
        typeof this.routeQuery.cache === "string"
            ? JSON.parse(this.routeQuery.cache)
            : this.routeQuery.cache
        ) {
            return false
        } else {
            this.routeQuery.cache = true
        }
        this.dataForm = {
                areaList: []
            }
        this.$refs.dataForm.resetFields()
        this.init()
        
    },
    mounted(){}
}
</script>

<style lang="scss">
.supplier-management-add{
    padding-top: 40px;
    color: #000000;
    font-weight: 400;
    background-color: #fff;
    padding-bottom: 106px;
    .footers{
        position: fixed;
        bottom: 42px;
        padding: 20px !important;
        width: calc(100% - 88px);
        left: 40px;
        background-color: #fff;
        z-index: 22;
        bottom: 41px;
    }
    .vxe-table .yellow-row {
        background: #fff7c0;
    }
    .red-cell{
        background-color: #f8839b;
        .increaseFlag_red {
        background-color: white;
        }
        .increaseFlag_blue{
        background-color: white;
        }
    }
    .vxe-table{
        .vxe-table--header-wrapper{
            tr{
                height: 45px;
                /* .vxe-cell::after{
                    content: ' *';
	                color: #ff1818;
                } */
            }
        }        
    }
    .blue-cell{
        background-color: #52b5ec;
        .increaseFlag_red {
        background-color: white;
        }
        .increaseFlag_blue{
        background-color: white;
        }
    }


    .el-table th.must>.cell:after {
	    content: ' *';
	    color: #ff1818;
    }
    .el-table__row{
        td{
            border-bottom: 1px solid #F0F2F5;
        }
    }
    .el-table{
        .el-table__header-wrapper{
            th{
                height: 45px;
                padding:10.5px 0
            }
        }
        .el-table__body-wrapper{
            .el-input__wrapper{
                background-color: #fff;
                height: 25px;
            }
            .el-form-item{
                margin-bottom: 0;
            }
            td{
                padding: 6px 0;
                .cell{
                    padding: 0;
                }
                &:nth-child(n+7){
                    padding: 0 10px;
                }
            }
        }
       
    }
    .el-cascader.el-tooltip__trigger.el-tooltip__trigger{
        width: 100%;
    }
    h3{
        font-size: 18px;
        line-height: 18px;
    }
    .el-alert{
        margin-bottom: 20px;
    }
    .title-1{
        margin-bottom: 37px;
    }
    .title-2{
        display: flex;
        justify-content: space-between;
        margin-bottom: 37px;
        font-size: 14px;
        cursor: pointer;
        .icon-svg{
            width: 24px;
            height: 24px;
            vertical-align: middle;
        }
    }
    .addCargo{
        width: 100%;
        height: 45px;
        margin-bottom:38px ;
        padding-left: 22px;
        background-color: #F2F7FF;
        text-align: left;
        font-size: 14px;
        line-height: 45px;
        
        .icon-svg{
            width: 24px;
            height: 24px;
            vertical-align: middle;
            cursor: pointer;
        }
        span {
            display: inline-block;
            width: 90px;
            cursor: pointer;
        }
    }
    .title-3{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 40px;
    }
    .footers {
        padding: 20px 0;
        margin: 0;
        margin-top: 40px;       
        text-align: center;
        border-top: 1px solid #F0F2F5;
    }
    .zhanghao{
        .el-dialog__footer{
            text-align: center;
        }
        .active{
            background-color: #F0F2F5;
            color: #000000;
            border-color: #c4c6cf;
        }
    }
}
</style>